import { Column, Row, TopbarContainer, TopbarTitle } from "@/components";

import { useSetTitle } from "@/hooks/useSetTitle";

import wrangle_bailey from "@/assets/wrangle_bailey.webp";
import wrangle_braden from "@/assets/wrangle_braden.webp";
import wrangle_corbin from "@/assets/wrangle_corbin.webp";
import wrangle_yousra from "@/assets/wrangle_yousra.webp";

export const MotivationPage = () => {
  useSetTitle({
    title: "Motivation",
  });

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle>Motivation</TopbarTitle>
      </TopbarContainer>
      <Row className="flex-1 items-center justify-center overflow-y-auto p-4">
        <Column className="items-center gap-4">
          <h1 className="text-4xl font-bold text-slate-700">
            Wrangle. Up.
          </h1>
          <div className="grid gap-4 md:grid-cols-2">
            <Column className="items-center gap-2">
              <img
                className="h-80 w-80 rounded-lg object-cover shadow-lg"
                src={wrangle_bailey}
              />
              <p className="text-center text-sm font-semibold text-slate-700">
                Stay focused.
              </p>
            </Column>
            <Column className="items-center gap-2">
              <img
                className="h-80 w-80 rounded-lg object-cover shadow-lg"
                src={wrangle_yousra}
              />
              <p className="text-center text-sm font-semibold text-slate-700">
                Never give up.
              </p>
            </Column>
            <Column className="items-center gap-2">
              <img
                className="h-80 w-80 rounded-lg object-cover shadow-lg"
                src={wrangle_corbin}
              />
              <p className="text-center text-sm font-semibold text-slate-700">
                You are capable.
              </p>
            </Column>
            <Column className="items-center gap-2">
              <img
                className="h-80 w-80 rounded-lg object-cover shadow-lg"
                src={wrangle_braden}
              />
              <p className="text-center text-sm font-semibold text-slate-700">
                Keep moving forward.
              </p>
            </Column>
          </div>
        </Column>
      </Row>
    </Column>
  );
};
